import requestUtils from 'api/requestUtils'
import type {
  FetchItemPolicyBudgetParams,
  ItemPolicyBudgetServerResponseWire,
} from 'businessTraveller/types/itemPolicyBudget.types'
import { mapItemPolicyBudgetResult } from 'businessTraveller/api/mappers/itemPolicyMappers'
import { normalizeFlightIataAirportCodeForItemPolicy } from 'businessTraveller/utils/normalizeFlightIataAirportCodeForItemPolicy'

function buildSearchParams(params: FetchItemPolicyBudgetParams): URLSearchParams {
  const searchParams = new URLSearchParams()
  searchParams.set('itemPolicyType', params.itemPolicyType)
  searchParams.set('currencyCode', params.currencyCode)
  searchParams.set('employeeIds', [...params.employeeIds].sort().join(','))

  if (params.itemPolicyType === 'HOTEL') {
    searchParams.set('numberOfNights', String(params.numberOfNights))
    searchParams.set('roomCount', String(params.roomCount))
    if (params.lePlaceId) {
      searchParams.set('lePlaceId', params.lePlaceId)
    }
    if (params.latitude && params.longitude) {
      searchParams.set('latitude', params.latitude)
      searchParams.set('longitude', params.longitude)
    }
  } else if (params.itemPolicyType === 'FLIGHT') {
    const departing =
      normalizeFlightIataAirportCodeForItemPolicy(params.departingAirportCode) ?? params.departingAirportCode
    const arriving =
      normalizeFlightIataAirportCodeForItemPolicy(params.arrivingAirportCode) ?? params.arrivingAirportCode
    searchParams.set('departingAirportCode', departing)
    searchParams.set('arrivingAirportCode', arriving)
    searchParams.set('flightViewType', params.flightViewType)
    searchParams.set('travellerCount', String(params.travellerCount))
  } else if (params.itemPolicyType === 'CAR_HIRE') {
    searchParams.set('numberOfDays', String(params.numberOfDays))
    searchParams.set('travellerCount', String(params.travellerCount))
  }

  return searchParams
}

async function requestGetItemPolicyBudget(
  params: FetchItemPolicyBudgetParams,
): Promise<App.BusinessTraveller.ItemPolicyBudgetResult> {
  const { businessId } = params
  if (!businessId) {
    return Promise.reject(new Error('requestGetItemPolicyBudget: missing businessId'))
  }
  const searchParams = buildSearchParams(params)

  const response = await requestUtils.get<ItemPolicyBudgetServerResponseWire>(
    `/api/business-traveller/businesses/${businessId}/item-policies/budgets?${searchParams.toString()}`,
    { credentials: 'include' },
  )

  return mapItemPolicyBudgetResult(response.result)
}

export default requestGetItemPolicyBudget
